var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('localization',{attrs:{"language":'sl-SI'}},[_c('intl',{attrs:{"locale":'sl'}},[_c('div',{class:_vm.wrapperClass,attrs:{"id":"wrapper"}},[_c('header',{staticClass:"header"},[_c('div',{staticClass:"adapt"},[_c('a',{staticClass:"logo_link",attrs:{"aria-label":"Na vstopno stran","href":"/","rel":"home"}},[_c('h1')]),_c('Menu')],1)]),_c('main',{staticClass:"main",attrs:{"id":"content"}},[_c('router-view'),_c('NotificationGroup',{style:({
        
        left: '15%',
        bottom: 0,
        alignItems: 'flex-start',
        flexWrap: 'wrap-reverse',
      })},[_c('Fade',{attrs:{"appear":_vm.alert.message?true:false}},[(_vm.alert.message)?_c('Notification',{attrs:{"type":{
            style: _vm.alert.n_type,
            icon: false,
          },"closable":true},on:{"close":function($event){return _vm.onClose()}}},[_c('span',[_vm._v(_vm._s(_vm.alert.message))])]):_vm._e()],1)],1)],1),_c('footer',{staticClass:"footer"})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }